import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";

interface EnhancedPageTitleProps {
  title: string;
  icon?: React.ReactNode;
  button1Text?: string;
  button1Action?: () => void;
  button2Text?: string;
  button2Action?: () => void;
}

const EnhancedPageTitle: React.FC<EnhancedPageTitleProps> = ({
  title,
  icon,
  button1Text,
  button1Action,
  button2Text,
  button2Action,
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3,
        p: 2,
        borderRadius: 2,
        backgroundColor: "#f5f5f5", // light gray like invoice
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        {icon}
        <Typography variant="h5" fontWeight="bold">
          {title}
        </Typography>
      </Box>
      <Box display="flex" gap={1}>
        {button1Text && button1Action && (
          <Button variant="contained" onClick={button1Action}>
            {button1Text}
          </Button>
        )}
        {button2Text && button2Action && (
          <Button variant="outlined" onClick={button2Action}>
            {button2Text}
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default EnhancedPageTitle;
